// File: src/components/finance/FinanceProcess.jsx
import React from "react";
import "../../styles/FinanceProcess.css";

const FinanceProcess = () => {
  const processSteps = [
    {
      number: "1",
      title: "Check your used car loan eligibility",
      description: "Fill in a form online to know your second hand car loan eligibility in minutes, without impacting your credit score.",
      linkText: "Calculate car loan EMI",
      illustration: (
        <svg width="200" height="200" viewBox="0 0 200 200">
          <rect x="40" y="60" width="120" height="80" rx="8" fill="#E0E7FF" stroke="#7C3AED" strokeWidth="2"/>
          <circle cx="100" cy="90" r="20" fill="#FCD34D"/>
          <path d="M85 115h30" stroke="#7C3AED" strokeWidth="4" strokeLinecap="round"/>
          <circle cx="130" cy="40" r="25" fill="#FF6B6B"/>
          <text x="130" y="48" fontSize="20" fill="#FAFAFA" textAnchor="middle">₹</text>
        </svg>
      )
    },
    {
      number: "2",
      title: "Upload documents",
      description: "Upload your documents online and you'll be served the best used car loan deal, customized just for you by our finance partners.",
      illustration: (
        <svg width="200" height="200" viewBox="0 0 200 200">
          <rect x="50" y="40" width="100" height="120" rx="8" fill="#FEF3C7" stroke="#F59E0B" strokeWidth="2"/>
          <path d="M70 70h60M70 90h40M70 110h50" stroke="#F59E0B" strokeWidth="3" strokeLinecap="round"/>
          <path d="M100 140l-15 15h30l-15-15z" fill="#7C3AED"/>
          <rect x="85" y="135" width="30" height="5" fill="#7C3AED"/>
          <text x="100" y="148" fontSize="12" fill="#FAFAFA" textAnchor="middle">UPLOADING</text>
        </svg>
      )
    },
    {
      number: "3",
      title: "Same-day approval",
      description: "With Spinny, get same-day approval and complete disbursal formalities at your convenience.",
      illustration: (
        <svg width="200" height="200" viewBox="0 0 200 200">
          <circle cx="100" cy="80" r="40" fill="#D1FAE5" stroke="#10B981" strokeWidth="3"/>
          <path d="M80 80l10 10 20-20" stroke="#10B981" strokeWidth="4" fill="none" strokeLinecap="round"/>
          <rect x="60" y="130" width="80" height="40" rx="8" fill="#E0E7FF" stroke="#7C3AED" strokeWidth="2"/>
          <text x="100" y="155" fontSize="14" fill="#7C3AED" textAnchor="middle" fontWeight="bold">APPROVED</text>
          <path d="M150 60l5 8-8-2-2 8-5-8 8 2 2-8z" fill="#FCD34D"/>
        </svg>
      )
    },
    {
      number: "4",
      title: "Home delivery",
      description: "Your polished, cleaned and serviced Spinny Assured® car is delivered the same day, right at your doorstep.",
      illustration: (
        <svg width="200" height="200" viewBox="0 0 200 200">
          <ellipse cx="100" cy="140" rx="60" ry="10" fill="#E5E7EB"/>
          <rect x="50" y="80" width="100" height="50" rx="25" fill="#7C3AED"/>
          <circle cx="70" cy="130" r="12" fill="#0A0A0A"/>
          <circle cx="130" cy="130" r="12" fill="#0A0A0A"/>
          <rect x="85" y="65" width="30" height="20" rx="4" fill="#FCD34D"/>
          <circle cx="100" cy="50" r="20" fill="#FF9B9B"/>
          <path d="M90 45c0-5 5-10 10-10s10 5 10 10" stroke="#8B5CF6" strokeWidth="3" fill="none"/>
        </svg>
      )
    }
  ];

  return (
    <section className="finance-process">
      <div className="process-container">
        {processSteps.map((step, index) => (
          <div key={index} className="process-step">
            <div className="step-illustration">
              {step.illustration}
              <div className="step-number">{step.number}</div>
            </div>
            <div className="step-content">
              <h3>{step.title}</h3>
              <p>{step.description}</p>
              {step.linkText && (
                <a href="#calculator" className="step-link">
                  {step.linkText} now!
                </a>
              )}
            </div>
            {index < processSteps.length - 1 && (
              <div className="step-connector">
                <svg width="100%" height="4" viewBox="0 0 200 4">
                  <path d="M0 2 Q50 2 100 2 T200 2" stroke="#E5E7EB" strokeWidth="4" fill="none" strokeDasharray="8,8"/>
                </svg>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FinanceProcess;